import { InferOutput, literal, object } from 'valibot'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { EntityTypeMeta, entityTypeDefaults } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_LAND_FLOOR_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.Forest,
  layer_id: EntityLayerId.TerrainL1,
  floor_e: ELEVATION_LAND_FLOOR_DEFAULT,
} as const

export const ForestEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.Forest),
  layer_id: literal(EntityLayerId.TerrainL1),
  id: EntityIdSchema,
  floor_e: EntityElevationSchema,
  ...HasXYSchema.entries,
})

export type ForestEntity = InferOutput<typeof ForestEntitySchema>

/**
 * Dense area covered with trees and undergrowth, providing natural cover.
 */
export const ForestEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.Forest,
  dname: 'Forest',
  layer_id: EntityLayerId.TerrainL1,
  group_id: EntityTypeGroupId.Terrain,
  defense: 2,
  blocksVision: true,
  entDefaults,
}

export function createForestEntity(id: number, x: number, y: number): ForestEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
  }
}
